var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "object-definitions" },
    [
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { md: "12", xs: "12" } },
                [
                  _c(
                    "v-tabs",
                    { attrs: { "show-arrows": "" } },
                    [
                      _c("v-tab", [_vm._v("Target Object")]),
                      _c("v-tab", [_vm._v("Target Object Attribute")]),
                      _c("v-tab", [_vm._v("Target Calculation")]),
                      _c("v-tab", [_vm._v("Target Source Attribute")]),
                      _c("v-tab", [_vm._v("Source Object")]),
                      _c("v-tab", [_vm._v("Source Object Attribute")]),
                      _c("v-tab", [_vm._v("Subject Area")]),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "dashboard-card",
                            { attrs: { minHeight: "300" } },
                            [_c("target-object")],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "dashboard-card",
                            { attrs: { minHeight: "300" } },
                            [_c("target-object-attribute")],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "dashboard-card",
                            { attrs: { minHeight: "300" } },
                            [_c("target-calculation")],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "dashboard-card",
                            { attrs: { minHeight: "300" } },
                            [_c("target-source-attribute")],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "dashboard-card",
                            { attrs: { minHeight: "300" } },
                            [_c("source-object")],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "dashboard-card",
                            { attrs: { minHeight: "300" } },
                            [_c("source-object-attribute")],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "dashboard-card",
                            { attrs: { minHeight: "300" } },
                            [_c("subject-areas-index")],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }